import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight, Hexagon } from "lucide-react";
import { FadeUp, MaskedLines } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Tips() {
  const [tips, setTips] = useState(null);

  useEffect(() => {
    axios.get(`${API}/tips/public`).then((r) => setTips(r.data.tips)).catch(() => setTips([]));
  }, []);

  return (
    <>
      <section className="bg-forest-deep text-bone" data-testid="tips-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-14">
          <FadeUp>
            <p className="text-xs uppercase tracking-[0.3em] text-honey mb-6">Free Email Series</p>
          </FadeUp>
          <h1 className="font-display font-medium tracking-tighter leading-[0.95] text-[clamp(2.6rem,6vw,5rem)]" data-testid="tips-heading">
            <MaskedLines
              lines={[
                <span key="a">Beekeeping</span>,
                <span key="b"><em className="text-honey not-italic font-semibold">Basics.</em></span>,
              ]}
              delay={0.2}
            />
          </h1>
          <FadeUp delay={0.7} className="mt-6 max-w-xl">
            <p className="text-bone/60 leading-relaxed">
              Four practical tips from the field — the same series launch list members get
              by email, free to read and share.
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 py-16 md:py-24" data-testid="tips-list">
        {!tips ? (
          <p className="text-center text-ink/40 py-10">Loading...</p>
        ) : (
          <div className="flex flex-col gap-14">
            {tips.map((tip, i) => (
              <FadeUp key={tip.title} delay={i * 0.06}>
                <article className="border-t border-forest/15 pt-8" data-testid={`tip-card-${i + 1}`}>
                  <span className="font-display text-honey-dark text-lg">{String(i + 1).padStart(2, "0")}</span>
                  <h2 className="font-display text-3xl md:text-4xl text-forest tracking-tight mt-2 mb-5">{tip.title}</h2>
                  {tip.paragraphs.map((p, j) => (
                    <p key={j} className="text-ink/60 leading-relaxed max-w-2xl mb-4">{p}</p>
                  ))}
                </article>
              </FadeUp>
            ))}
          </div>
        )}

        <FadeUp delay={0.2} className="mt-20 text-center bg-forest rounded-[2rem] px-8 py-14" data-testid="tips-cta">
          <Hexagon className="w-8 h-8 text-honey mx-auto mb-5" strokeWidth={1.5} />
          <h2 className="font-display text-3xl md:text-4xl text-bone tracking-tight mb-4">
            Get tips like these in your inbox.
          </h2>
          <p className="text-bone/60 max-w-md mx-auto mb-8">
            Join the launch list and tick the Beekeeping Basics box — one tip every few
            days until launch, free.
          </p>
          <Link
            to="/pre-register?src=tips"
            data-testid="tips-cta-button"
            className="group inline-flex items-center gap-2 bg-honey text-forest font-semibold px-8 py-4 rounded-full transition-colors duration-300 hover:bg-honey-light"
          >
            Join the Launch List
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </FadeUp>
      </section>
    </>
  );
}
